import ECheckTableDesktop from './ECheckTableDesktop';

export default ECheckTableDesktop;
